import { Component, EventEmitter, OnInit, AfterViewInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ColDef, ColumnApi, GridApi, GridReadyEvent } from 'ag-grid-community';
import { Location } from '@angular/common';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { StorageService } from 'src/app/_services/storage.service';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { SideNavService } from 'src/app/views/layout/sidebar/side-name.service';
import { SidebarComponent } from 'src/app/views/layout/sidebar/sidebar.component';
import { environment } from 'src/environments/environment';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../customer-service';
import * as feather from 'feather-icons';

const { defaultPageSizeArr, defaultPageSize } = environment;

@Component({ 
  selector: 'app-customer-event',
  templateUrl: './customer-event.component.html',
  styleUrls: ['./customer-event.component.scss']
})
export class CustomerEventComponent implements OnInit, AfterViewInit {
  @Output() customerSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  
  public quickFilterShow: boolean = false;
  // Remove these NgbDateStruct properties
  // searchFromDate: NgbDateStruct | null = null;
  // searchToDate: NgbDateStruct | null = null;
  // minToDate: NgbDateStruct | null = null;
  
  // Add these properties for datetime-local inputs
  startDateTime: string = '';
  endDateTime: string = '';
  currentDateTime: string = '';
  
  // Add form group for date filters
  eventForm: FormGroup;
  submitted = false;
  
  public permissions: any = '';
  public userId: string = '';
  public mobileNumber: string = '';
  public eventAction: any = null;
  public eventActionOptions: any[] = []; // Array to store event action options
  public sort: string = 'DESC';
  public userType: string = '';
  // Add pagination properties
  pageNumber: number = 0; // Backend usually expects 0-based page index
  pageSize: number = 10;  // Default page size
  totalElements: number = 0;
  totalPages: number = 0;
  totalRecords: any;
  tableInfo: any;
  maxSize: number;
  // Add properties for search filters
  searchFromDate: NgbDateStruct | null = null;
  searchToDate: NgbDateStruct | null = null;
  ellipses: boolean = true;
  private gridApi!: GridApi;
  public rowData: any[] = [];
  public flattenedData: any[] = []; // To store flattened data for display
  Resultdata: any;
  private gridColumnApi!: ColumnApi;
  currentDate: any = new Date();
  private filterObj: any = {};
  globalSearch: string = '';
  private innerWidth: number;
  modalConfigReport: ModalConfig;
  loading: boolean = false;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  maxDateFrom: NgbDateStruct;
  selectedEventDetails: any[] = []; // To store events for a selected group

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };
  
  @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;
  @ViewChild('filSearchToDate') private filSearchToDate: FormControl;
  @ViewChild('filSearchFromDate') private filSearchFromDate: FormControl;

  public columnDefs: ColDef[] = [];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  constructor(
    private menuService: MenusService,
    private location: Location,
    private alertService: AlertService,
    private sideNavService: SideNavService,
    private router: Router,
    private sidebarComponent: SidebarComponent,
    private storageService: StorageService,
    private ngbCalender: NgbCalendar,
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private customerService: CustomerService,
    private _FB: FormBuilder
  ) {
    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDate = this.ngbCalender.getToday();
    
    // Initialize current datetime
    const now = new Date();
    this.currentDateTime = now.toISOString().slice(0, 16);
  }

  async ngOnInit(): Promise<void> {
    this.innerWidth = window.innerWidth;
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      });
      await this.router.navigateByUrl('/');
    }
    
    // Initialize form group
    this.eventForm = this._FB.group({
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required]
    });

    // Don't initialize userType or make API calls until tab is selected
    this.updateModalConfig();
  }

  updateModalConfig() {
    let modalTitle = "User Event Details";
    if (this.userType === 'MERCHANT') {
      modalTitle = "Merchant Event Details";
    } else if (this.userType === 'CUSTOMER') {
      modalTitle = "Customer Event Details";
    }
    
    this.modalConfigReport = {
      modalTitle: modalTitle,
      modalSize: 'xl',
      hideDismissButton(): boolean {
        return true;
      },
      hideCloseButton(): boolean {
        return true;
      }
    };
  }

  generateColumnDefinitions() {
    // Don't generate columns if userType is not selected
    if (!this.userType) {
      this.columnDefs = [];
      return;
    }
    
    if (this.userType === 'MERCHANT') {
      this.columnDefs = [
        { field: 'eventAction', headerName: 'Event Action', lockVisible: true },
        { field: 'merchantId', headerName: 'Merchant ID', lockVisible: true },
        { field: 'mobileNumber', headerName: 'Mobile Number', lockVisible: true },
        { field: 'merchantName', headerName: 'Merchant Name', lockVisible: true },
        { field: 'eventCount', headerName: 'Event Count', lockVisible: true },
        { 
          headerName: 'Actions', 
          lockVisible: true,
          cellRenderer: (params: any) => {
            return `<button class="btn btn-sm btn-outline-primary view-details-btn" style="color:rgb(0, 0, 0); font-weight: 500;">
            <i data-feather="eye" class="me-1 icon-sm"></i> View Details
          </button>`;
          },
          onCellClicked: (params: any) => {
            this.showEventDetails(params.data);
          }
        }
      ];
    } else {
      this.columnDefs = [
        { field: 'eventAction', headerName: 'Event Action', lockVisible: true },
        { field: 'mobileNumber', headerName: 'Mobile Number', lockVisible: true },
        { field: 'eventCount', headerName: 'Event Count', lockVisible: true },
        { 
          headerName: 'Actions', 
          lockVisible: true,
          cellRenderer: (params: any) => {
            return `<button class="btn btn-sm btn-outline-primary view-details-btn" style="color:rgb(0, 0, 0); font-weight: 500;">
            <i data-feather="eye" class="me-1 icon-sm"></i> View Details
          </button>`;
          },
          onCellClicked: (params: any) => {
            this.showEventDetails(params.data);
          }
        }
      ];
    }

    this.columnDefsCopy = [...(this.columnDefs.filter((col) => !col?.hide))];
    this.tableSelectedColumn = [...(this.columnDefs.filter((col) => !col?.hide))];

    if (this.gridApi) {
      try {
        this.gridApi.setColumnDefs(this.tableSelectedColumn);
        this.gridApi.setDefaultColDef(this.defaultColDef);
      } catch (err) {
        console.warn('Unable to set grid column defs yet', err);
      }
    }
  }
  
  // Method to fetch event action options from API
  getEventActionOptions(userType?: string) {
    this.customerService.getEventConstants(userType).subscribe(
      (response: any) => {
        console.log('Event constants response:', response);
        if (response && Array.isArray(response)) {
          this.eventActionOptions = response;
        } else {
          console.error('Unexpected response format for event constants:', response);
          this.eventActionOptions = [];
        }
      },
      (error) => {
        console.error('Error fetching event constants:', error);
        this.eventActionOptions = [];
      }
    );
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    // Don't make API calls until userType is selected
    if (this.userType) {
      this.getCustomerEvents();
    }
  }

  getCustomerEvents(page: number = this.pageNumber, size: number = this.pageSize) {
    // Don't make API calls if userType is not selected
    if (!this.userType) {
      this.loading = false;
      return;
    }
    
    this.loading = true;

    if (this.userType === 'MERCHANT') {
      // Merchant events API
      this.getMerchantEvents(page, size);
    } else {
      // Customer events API
      this.getCustomerEventsData(page, size);
    }
  }

  getCustomerEventsData(page: number, size: number) {
    const filters: any = {};
  
    if (this.userId) {
      filters.userId = this.userId;
    }
  
    if (this.mobileNumber) {
      filters.mobileNumber = this.mobileNumber;
    }
  
    if (this.eventAction) {
      const raw = typeof this.eventAction === 'string' ? this.eventAction : (this.eventAction?.eventConstant || this.eventAction);
      filters.eventAction = raw ? raw.toString().toUpperCase() : raw;
    }

    // Format date parameters according to the required format: yyyy-MM-dd HH:mm:ss
    if (this.startDateTime && this.endDateTime) {
      const fromDate = new Date(this.startDateTime);
      const toDate = new Date(this.endDateTime);
  
      const fromDateStr = this.formatDateForBackend(fromDate, true);
      const toDateStr = this.formatDateForBackend(toDate, false);
  
      filters.eventTime = `gte=${fromDateStr}$lte=${toDateStr}`;
    } else if (this.startDateTime) {
      const fromDate = new Date(this.startDateTime);
      filters.eventTime = `gte=${this.formatDateForBackend(fromDate, true)}`;
    } else if (this.endDateTime) {
      const toDate = new Date(this.endDateTime);
      filters.eventTime = `lte=${this.formatDateForBackend(toDate, false)}`;
    }
  
    // Add pagination parameters with the correct names
    filters.page_no = page;
    filters.page_size = size;
  
    this.customerService.getCustomerEvents(filters).subscribe(
      (response: any) => {
        this.loading = false;
        console.log('API Response:', response);
        
        // Handle no content response (204)
        if (response?.response?.status === 204 || response?.response?.httpStatus === "NO_CONTENT") {
          this.alertService.simpleAlert(
        
         response.response.message || "No user events found.",
         
          );
          
          // Clear the grid data
          this.rowData = [];
          this.totalElements = 0;
          this.totalPages = 0;
          
          // Force grid to refresh with empty data
          if (this.gridApi) {
            this.gridApi.setRowData([]);
          }
          return;
        }
        
        // Handle new response structure with response.data wrapper
        if (response?.response?.data?.content) {
          console.log('Processing paginated response with response.data structure');
          this.processAggregatedData(response.response.data.content);
          this.totalElements = response.response.data.totalElements;
          this.totalPages = response.response.data.totalPages;
          this.pageNumber = response.response.data.number;
          this.pageSize = response.response.data.size;
        }
        // Handle previous response structure with data.content
        else if (response?.data?.content) {
          console.log('Processing paginated response with data structure');
          this.processAggregatedData(response.data.content);
          this.totalElements = response.data.totalElements;
          this.totalPages = response.data.totalPages;
          this.pageNumber = response.data.number;
          this.pageSize = response.data.size;
        }
        // Fallback to previous structure handling
        else if (response && response.content) {
          console.log('Processing legacy content property');
          this.processAggregatedData(response.content);
          this.totalElements = response.totalElements;
          this.totalPages = response.totalPages;
          this.pageNumber = response.number;
          this.pageSize = response.size;
        }
        else if (Array.isArray(response)) {
          console.log('Processing array response');
          this.processAggregatedData(response);
          this.totalElements = response.length;
          this.totalPages = 1;
        }
        else {
          console.error('Unexpected response format:', response);
          this.rowData = [];
          this.totalElements = 0;
          this.totalPages = 0;
        }
      },
      (error) => {
        this.loading = false;
        console.error('API Error:', error);
        this.alertService.errorAlert({
          title: "Error",
          text: "Failed to fetch customer events",
          backdrop: true
        });
      }
    );
  }

  getMerchantEvents(page: number, size: number) {
    const filters: any = {};

    filters.page_no = page;
    filters.page_size = size;

    if (this.userId) {
      filters.userId = this.userId;
    }

    if (this.mobileNumber) {
      filters.mobileNumber = this.mobileNumber;
    }

    if (this.eventAction) {
      const raw = typeof this.eventAction === 'string' ? this.eventAction : (this.eventAction?.eventConstant || this.eventAction);
      filters.eventAction = raw ? raw.toString().toUpperCase() : raw;
    }

    if (this.startDateTime && this.endDateTime) {
      const fromDate = new Date(this.startDateTime);
      const toDate = new Date(this.endDateTime);
  
      const fromDateStr = this.formatDateForBackend(fromDate, true);
      const toDateStr = this.formatDateForBackend(toDate, false);
  
      filters.eventTime = `gte=${fromDateStr}$lte=${toDateStr}`;
    } else if (this.startDateTime) {
      const fromDate = new Date(this.startDateTime);
      filters.eventTime = `gte=${this.formatDateForBackend(fromDate, true)}`;
    } else if (this.endDateTime) {
      const toDate = new Date(this.endDateTime);
      filters.eventTime = `lte=${this.formatDateForBackend(toDate, false)}`;
    }

    this.customerService.getMerchantEvents(filters).subscribe({
      next: (response: any) => {
        this.loading = false;
        console.log('Merchant API Response:', response);
        
        if (response?.response?.data?.content) {
          console.log('Processing merchant response with response.data structure');
          this.processMerchantData(response.response.data.content);
          this.totalElements = response.response.data.totalElements;
          this.totalPages = response.response.data.totalPages;
          this.pageNumber = response.response.data.number;
          this.pageSize = response.response.data.size;
        } else if (response?.data?.content) {
          console.log('Processing merchant response with data structure');
          this.processMerchantData(response.data.content);
          this.totalElements = response.data.totalElements;
          this.totalPages = response.data.totalPages;
          this.pageNumber = response.data.number;
          this.pageSize = response.data.size;
        } else if (Array.isArray(response)) {
          console.log('Processing merchant array response');
          this.processMerchantData(response);
          this.totalElements = response.length;
          this.totalPages = 1;
        } else {
          console.error('Unexpected merchant response format:', response);
          this.rowData = [];
          this.totalElements = 0;
          this.totalPages = 0;
        }
      },
      error: (error) => {
        this.loading = false;
        console.error('Merchant API Error:', error);
        this.alertService.errorAlert({
          title: "Error",
          text: "Failed to fetch merchant events",
          backdrop: true
        });
      }
    });
  }

  processMerchantData(content: any[]) {
    console.log('Processing merchant data:', content);
    const processedData: any[] = [];
    
    if (Array.isArray(content)) {
      content.forEach(item => {
        if (item && item.eventAction) {
          processedData.push({
            eventAction: item.eventAction || 'N/A',
            merchantName: item.merchantName || item.merchant_name || 'N/A',
            merchantId: item.merchantId || item.userId || item.merchant_id || 'N/A',
            mobileNumber: item.mobileNumber || item.mobile_number || 'N/A',
            eventCount: item.eventDetails ? item.eventDetails.length : 0,
            events: item.eventDetails || []
          });
        }
      });
    }
    
    console.log('Processed merchant data:', processedData);
    this.rowData = processedData;
    
    // Force grid to refresh
    if (this.gridApi) {
      this.gridApi.setRowData(this.rowData);
    }
  }

  // Helper method to format date as yyyy-MM-dd HH:mm:ss
  formatDateForBackend(date: Date, isStart: boolean): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = isStart ? '00' : '23';
    const minutes = isStart ? '00' : '59';
    const seconds = isStart ? '00' : '59';
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  // Process the aggregated data from the API response
  processAggregatedData(content: any[]) {
    console.log('Processing data:', content);
    const processedData: any[] = [];
    
    if (Array.isArray(content)) {
      content.forEach(item => {
        if (item && item.eventAction) {
          processedData.push({
            eventAction: item.eventAction || 'N/A',
            mobileNumber: item.mobileNumber || 'N/A',
            eventCount: item.eventDetails ? item.eventDetails.length : 0,
            events: item.eventDetails || [] // Store all events for this action/mobile
          });
        }
      });
    }
    
    console.log('Processed data:', processedData);
    this.rowData = processedData;
    
    // Force grid to refresh
    if (this.gridApi) {
      this.gridApi.setRowData(this.rowData);
    }
  }

  // Show event details in the modal
  // Show event details in the modal
  showEventDetails(data: any) {
  if (data && data.events) {
  // Transform event details for display
  this.selectedEventDetails = data.events.map((event: any) => {
  return {
  eventMessage: event.eventMessage || 'N/A',
  eventType: event.eventType || 'N/A',
  eventStatus: event.eventStatus || 'N/A',
  eventTime: event.eventTime || 'N/A',
  mobileNumber: event.mobileNumber || 'N/A'
  };
  });
  
  this.tableInfo = {
  mobileNumber: data.mobileNumber || data.mobile_number || data.merchantId || data.merchantId,
  merchantName: data.merchantName || data.merchant_name || null,
  eventAction: data.eventAction
  };
  
  this.modalReportComponent.open();
  }
  }

  clearFilters() {
    this.userId = '';
    this.mobileNumber = '';
    this.eventAction = null;
    this.pageSize = 10;
    // Update to use the new datetime properties
    this.startDateTime = '';
    this.endDateTime = '';
    this.eventForm.reset();
    // Only make API call if userType is selected
    if (this.userType) {
      this.getCustomerEvents();
    }
  }

  applyFilters() {
    // Only make API call if userType is selected
    if (this.userType) {
      this.getCustomerEvents();
    }
  }

  exportToExcel() {
    // Export functionality would go here
  }

  // Add these methods to fix the template errors
  fun(id: string) {
    // Add your focus logic here
    console.log('Element focused:', id);
  }

  funover(id: string) {
    // Add your focus out logic here
    console.log('Element focus out:', id);
  }

  // Add this method to update minToDate when from date changes
  onFromDateSelect(): void {
    if (this.searchFromDate) {
      this.minDate = {...this.searchFromDate};
      
      // If to date is before from date, reset it
      if (this.searchToDate && this.compareDates(this.searchToDate, this.searchFromDate) < 0) {
        this.searchToDate = null;
      }
    }
  }
  
  // Helper method to compare dates
  compareDates(date1: NgbDateStruct, date2: NgbDateStruct): number {
    if (date1.year !== date2.year) {
      return date1.year - date2.year;
    }
    if (date1.month !== date2.month) {
      return date1.month - date2.month;
    }
    return date1.day - date2.day;
  }

  ngAfterViewInit(): void {
    // Initialize Feather icons
    if (typeof feather !== 'undefined') {
      feather.replace();
    }
  }

  // Add Math reference for template usage
  Math = Math;

  // Pagination methods
  onPageChange(page: number): void {
    // Ensure page is within valid range
    if (page < 0) {
      page = 0;
    } else if (page >= this.totalPages) {
      page = this.totalPages - 1;
    }
    
    if (this.pageNumber !== page) {
      this.pageNumber = page;
      // Only make API call if userType is selected
      if (this.userType) {
        this.getCustomerEvents(this.pageNumber, this.pageSize);
      }
    }
  }

  onPageSizeChange(size: number): void {
    if (this.pageSize !== size) {
      this.pageSize = size;
      this.pageNumber = 0; // Reset to first page when changing page size
      // Only make API call if userType is selected
      if (this.userType) {
        this.getCustomerEvents(this.pageNumber, this.pageSize);
      }
    }
  }

  getPageNumberToShow(index: number): number {
    // Calculate which page numbers to show based on current page
    if (this.totalPages <= 5) {
      // If 5 or fewer pages, just show all pages in order
      return index;
    } else {
      // For more than 5 pages, show a window of pages around the current page
      if (this.pageNumber <= 2) {
        // For first 3 pages, show pages 0-4
        return index;
      } else if (this.pageNumber >= this.totalPages - 3) {
        // For last 3 pages, show the last 5 pages
        return this.totalPages - 5 + index;
      } else {
        // Otherwise show 2 pages before and 2 pages after current page
        return this.pageNumber - 2 + index;
      }
    }
  }


  // Add getter for easy access to form controls
  get eventFormControls() {
    return this.eventForm.controls;
  }
  
  // Add methods for datetime changes
  onStartDateTimeChange() {
    if (this.startDateTime) {
      // If end date is before start date, update it
      if (this.endDateTime && this.endDateTime < this.startDateTime) {
        this.endDateTime = this.startDateTime;
      }
    }
  }

  onEndDateTimeChange() {
    // Validation can be added here if needed
  }

  getDataByUserType(userType: string) {
    this.userType = userType;
    console.log('User type changed to:', userType);
    
    this.eventAction = null;
    
    this.getEventActionOptions(userType);
    
    this.generateColumnDefinitions();
    this.updateModalConfig();
    this.pageNumber = 0;
    this.getCustomerEvents(this.pageNumber, this.pageSize);
  }



}
